export default __webpack_public_path__ + "static/media/gab3.16c861cf.png";